import React, { useEffect } from "react";
import ButtonHome from "./ButtonHome";
import ButtonRetry from "./ButtonRetry";
import clicksound from "./music/click.mp3";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const ModalGameSelesai = ({
  show,
  score,
  closeModal,
  onReset,
  englishscore,
  levels,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (show) {
      updateGameHistory();
    }
  }, [show]);
  if (!show) return null;

  const playClickSound = () => {
    const audio = new Audio(clicksound);
    audio.play();
  };

  const handleRetry = () => {
    playClickSound();
    onReset();
    closeModal();
  };

  const handleHome = () => {
    playClickSound();
    closeModal();
  };

  const updateGameHistory = () => {
    // Get current date and time
    const currentDateTime = new Date();
    const formattedDateTime = `${currentDateTime
      .getDate()
      .toString()
      .padStart(2, "0")}/${(currentDateTime.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${currentDateTime.getFullYear()} ${currentDateTime
      .getHours()
      .toString()
      .padStart(2, "0")}:${currentDateTime
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

    // Create new history entry
    const newHistory = {
      date: formattedDateTime,
      level: levels,
      score: score,
      englishscore: englishscore,
    };

    // Get existing history from local storage
    const existingHistory =
      JSON.parse(localStorage.getItem("gameHistory")) || [];

    // Add the new history entry to the existing history
    const updatedHistory = [...existingHistory, newHistory];

    // Save updated history to local storage
    localStorage.setItem("gameHistory", JSON.stringify(updatedHistory));
  };

  return (
    <div className="modal-overlay-game flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
      <div className="modal-content-game bg-gambar lg:py-16 lg:px-16 sm:py-10 text-center relative flex flex-col items-center lg:w-[25rem;] sm:w-[15rem]">
        <div className="modal-body-game mb-6">
          <h2 className="winner-title-game lg:text-3xl sm:text-lg font-bold">
            {t("you_win")}
          </h2>
          <p className="score-title-game lg:text-2xl sm:text-sm font-bold rounded-full lg:p-5 sm:p-2">
            {t("highest_level")}
          </p>
          <h3 className="score-title-game lg:p-5 lg:text-2xl sm:text-md sm:p-2 font-bold">
            {t("game_score")}
          </h3>
          <p className="score-game lg:text-3xl sm:text-xl font-bold">{score}</p>
          <h3 className="score-title-game lg:p-5 lg:text-2xl sm:text-md sm:p-2 font-bold">
            {t("english_score")}
          </h3>
          <p className="score-game lg:text-3xl sm:text-xl font-bold">
            {englishscore}
          </p>
        </div>
        <div className="modal-footer-game lg:mb-5 flex lg:gap-4 sm:gap-2">
          <ButtonHome closeModal={handleHome} />
          <ButtonRetry onClick={handleRetry} />
        </div>
      </div>
    </div>
  );
};

export default ModalGameSelesai;
